import ModalScam from './ModalScam.jsx';

export default ModalScam;